import { render, staticRenderFns } from "./CitiesPage.vue?vue&type=template&id=4238fab6&"
import script from "./CitiesPage.vue?vue&type=script&lang=js&"
export * from "./CitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports